import {API_URL} from '../constants/index.js';
import {
    ADD_APP,
    ADD_APP_ERROR,
    ADD_APP_SUCCESS,
    GET_APPS,
    GET_APPS_SUCCESS,
    GET_APPS_ERROR,
    UPDATE_APPS,
    UPDATE_APPS_ERROR,
    UPDATE_APPS_SUCCESS,
} from '../constants/appsConstants';

import {sweetAlert} from '../components/Alert/sweetAlert'

//POST APP
export function addApp(data){
    return{
        type: ADD_APP,
        data
    }
}

export function addAppSuccess(data){
return{
    type: ADD_APP_SUCCESS,
    data
}
}

export function addAppError(data){
return{
    type: ADD_APP_ERROR,
    data
}
}

export function AddApp(appToSave){
const headers ={
    'Content-Type':'application/json' ,
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Authorization': 'Bearer '+localStorage.getItem('token'),
};

const url = `${API_URL}home-apps/addApp`;

return dispatch => {
    dispatch(addApp());

    return fetch(url,
    {
        body: JSON.stringify(appToSave),
        method: 'POST',
        headers:  headers
    })
    .then(res => res.json())
    .then(res => {

        const message ='App added successfully';
        const data = (res)? res: undefined;

        dispatch(addAppSuccess(data));
        sweetAlert('success', message, 'alert_Update_Success');

        return data;
    })
    .catch(error => {
        const message ='Error adding app';
        dispatch(addAppError(error));
        sweetAlert('error', message, 'alert_Update_Success');
    })
};
}

//GET APPS
export function getApps(data){
        return{
            type: GET_APPS,
            data
        }
}

export function getAppsSuccess(data){
    return{
        type: GET_APPS_SUCCESS,
        data
    }
}

export function getAppsError(data){
    return{
        type: GET_APPS_ERROR,
        data
    }
}

export function GetApps(communityId){
    const headers ={
        'Content-Type':'application/json' ,
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Authorization': 'Bearer '+localStorage.getItem('token'),
        'CommunityId': communityId
    };

    const url = `${API_URL}home-apps/getAllApps`;

    return dispatch => {
        dispatch(getApps());

        return fetch(url,
        {
            method: 'GET',
            headers:  headers
        })
        .then(res => res.json())
        .then(res => {

            const data = (res && res.data)? res.data: undefined;

            dispatch(getAppsSuccess(data));

            return data;
        })
        .catch(error => {
            dispatch(getAppsError(error));
        })
    };
}

//UPDATE App


export function updateApp(data){
    return{
        type: UPDATE_APPS,
        data
    }
}

export function updateAppSuccess(data){
return{
    type: UPDATE_APPS_SUCCESS,
    data
}
}

export function updateAppsError(data){
return{
    type: UPDATE_APPS_ERROR,
    data
}
}

export function UpdateApp(appId, updateBody){

const headers ={
    'Content-Type':'application/json' ,
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Authorization': 'Bearer '+localStorage.getItem('token'),
};

const url = `${API_URL}home-apps/updateAppById/${appId}`;

return dispatch => {
    dispatch(updateApp());

    return fetch(url,
    {
        body: JSON.stringify(updateBody),
        method: 'PUT',
        headers:  headers
    })
    .then(res => {
        const message = 'App updated successfully';
        const data = (res && res.data)? res.data: undefined;

        dispatch(updateAppSuccess(data));

        sweetAlert('success', message, 'alert_Update_Success');

        return data;
    })
    .catch(error => {
        const message = 'Error updating app';
        dispatch(updateAppsError(error));
        sweetAlert('error', message, 'alert_Update_Success');
    })
};
}